import React, { Component } from 'react';
import {
  css
} from 'aphrodite';
import { Link } from 'react-router-dom';
import { Button } from '@material-ui/core';
import { Controller } from '../../common/Controller';
import { Styles } from './Styles'
import { CommonStyles } from '../../styles/Styles';

export class TableList extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
  }

  render() {
    return (
      <div className={css(Styles.innerContainer)}>
        <div className={css(CommonStyles.innerTableHeaderContainer)}>
          {this.props.tableColumnTitles.map(title => {
            return (
              <div className={css(CommonStyles.innerTableHeaderContent)}>
                <p className={css(CommonStyles.paragraphMargin)}>{title}</p>
              </div>
            )
          })}
          <div className={css(CommonStyles.innerTableHeaderSortContent)}></div>
        </div>
        {this.props.items !== undefined &&
          this.props.items.map(item => {
            return (
              <div className={css(Styles.innerTableContent)}>
                <div className={css(CommonStyles.tableInnerContent)}>
                  <p className={css(CommonStyles.paragraphMargin)}>{item.lp}</p>
                </div>
                <div className={css(CommonStyles.tableInnerContent)}>
                  <p className={css(CommonStyles.paragraphMargin)}>{item.ownerInfo ? item.ownerInfo.name : ''}</p>
                </div>
                <div className={css(CommonStyles.tableInnerContent)}>
                  <p className={css(CommonStyles.paragraphMargin)}>{item.ownerInfo ? item.ownerInfo.email : ''}</p>
                </div>
                <div className={css(CommonStyles.innerTableEditContent)}>
                  <div
                    aria-describedby={this.props.id}
                    onClick={(e) => this.props.editClick(e, item)}
                    className={css(Styles.editContent)}>
                    <img src={require('../../assets/images/more-rounded.svg')} />
                  </div>
                </div>
              </div>
            )
          })}
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/screens/GuestUsersDetails/TableList.js